import { lazy } from "react";

const RELOAD_GUARD_KEY = "hr_lazy_chunk_reload_at";
const RELOAD_GUARD_MS = 10_000;

function isDynamicImportFetchError(error) {
  const msg = String(error?.message || error || "");
  return (
    msg.includes("Failed to fetch dynamically imported module") ||
    msg.includes("error loading dynamically imported module") ||
    msg.includes("Importing a module script failed") ||
    /Loading chunk [\d]+ failed/i.test(msg)
  );
}

/**
 * React.lazy wrapper that recovers from Vite/dev (and rare prod) chunk fetch races
 * by reloading once instead of leaving the route ErrorBoundary stuck.
 */
export function lazyWithRetry(importer) {
  return lazy(async () => {
    try {
      return await importer();
    } catch (error) {
      if (
        isDynamicImportFetchError(error) &&
        typeof window !== "undefined" &&
        typeof sessionStorage !== "undefined"
      ) {
        const last = Number(sessionStorage.getItem(RELOAD_GUARD_KEY) || 0);
        if (!Number.isFinite(last) || Date.now() - last > RELOAD_GUARD_MS) {
          sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
          window.location.reload();
          return new Promise(() => {});
        }
      }
      throw error;
    }
  });
}
